import { render, staticRenderFns } from "./SupplierMobile.vue?vue&type=template&id=c915fc24&scoped=true"
import script from "./SupplierMobile.vue?vue&type=script&lang=js"
export * from "./SupplierMobile.vue?vue&type=script&lang=js"
import style0 from "./SupplierMobile.vue?vue&type=style&index=0&id=c915fc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c915fc24",
  null
  
)

export default component.exports